import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TokenStoreService} from './token-store.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(private tokenStore: TokenStoreService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // const token = this.auth.t
        // todo test if api needs token
        const token = this.tokenStore.token;
        console.log(`auth interceptor ${token}`);
        let handleRequest = req;
        if (token) {
            handleRequest = req.clone({
                setHeaders: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            });
        }
        return next.handle(handleRequest);
    }

}
